import { WeGoConfig } from './../../shared/config';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'wego-footer',
  template: `
  <footer class="main-footer">
    <div class="pull-right">
      <strong>{{ versionNumber }}</strong>
    </div>
    <strong>Copyright © {{copyRightYear}}  <a href="http://wegocarsharing.com" target="_blank"> wegocarsharing.com </a></strong> All rights
    reserved.
  </footer>
  `
})

export class FooterComponent implements OnInit, OnDestroy {
  versionNumber: string;
  copyRightYear: number;
  constructor() { }
  ngOnInit() {
    this.versionNumber = WeGoConfig.APP_VERSION;
    this.copyRightYear=(new Date()).getFullYear();
  }
  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-template/components/footer.component.ts